import { getEndOfDay, getStartOfDay } from '../../constants/DateUtil';
import { generateObjectWithCriteriaMode, getCombined } from '../../sagas/util';
import { getStringFromObject } from '../../constants/lodashUtils';

export const PATIENT_PORTAL_ENCOUNTER_SYNC_STATUSES = {
    DRAFT: 'DRAFT',
    SUCCESS: 'SUCCESS',
    ERROR: 'ERROR',
};

export const patientPortalEncounterSyncActions = {
    VIEW_ERROR: {
        key: 'viewError',
        value: 'View Error',
        hideIf: [
            { key: 'status', value: PATIENT_PORTAL_ENCOUNTER_SYNC_STATUSES.DRAFT },
            { key: 'status', value: PATIENT_PORTAL_ENCOUNTER_SYNC_STATUSES.SUCCESS },
        ],
    },
    FORCE_SYNC: {
        key: 'forceSync',
        value: 'Repush',
        privilege: ['patient.portal.encounter.sync.force'],
        hideIf: [
            { key: 'status', value: PATIENT_PORTAL_ENCOUNTER_SYNC_STATUSES.SUCCESS },
        ],
    },
};

export const generatePatientPortalEncounterSyncSearchConstruct = (filters) => {
    const startDate = getStringFromObject('datePeriod.startDate', filters);
    const endDate = getStringFromObject('datePeriod.endDate', filters);

    if (!startDate || !endDate) {
        return null;
    }

    let searchConstruct = getCombined(
        null,
        'AND',
        getCombined(
            generateObjectWithCriteriaMode(
                'patient_portal_encounter_sync.createdAt',
                getStartOfDay(new Date(startDate)).getTime(),
                '>=',
            ),
            'AND',
            generateObjectWithCriteriaMode(
                'patient_portal_encounter_sync.createdAt',
                getEndOfDay(new Date(endDate)).getTime(),
                '<=',
            ),
        ),
    );

    const patientUuid = getStringFromObject('patient.key', filters);
    if (patientUuid) {
        searchConstruct = getCombined(
            searchConstruct,
            'AND',
            generateObjectWithCriteriaMode('person.uuid', patientUuid, '='),
        );
    }

    const statusKey = getStringFromObject('status.key', filters);
    if (statusKey) {
        searchConstruct = getCombined(
            searchConstruct,
            'AND',
            generateObjectWithCriteriaMode('patient_portal_encounter_sync.status', statusKey, '='),
        );
    }

    return searchConstruct;
};

export const patientPortalEncounterSyncTableSchema = {
    fieldType: 'materialTable',
    id: 'table',
    name: 'patientPortalEncounterSync',
    showInNonEditableMode: true,
    showInReadOnlyMode: true,
    hideCheckBoxIcon: true,
    rowstyle: {
        height: '56px',
    },
    headerColStyle: {
        color: '#000000',
        fontSize: '14px',
    },
    tableCells: [
        {
            id: 'createdAt',
            name: 'createdAt',
            find: 'createdAt',
            label: 'Created At',
            fieldType: 'datetime',
        },
        {
            id: 'updatedAt',
            name: 'updatedAt',
            find: 'updatedAt',
            label: 'Last Updated At',
            fieldType: 'datetime',
        },
        {
            id: 'patientIdentifier',
            name: 'patientIdentifier',
            find: 'patientIdentifier',
            label: 'Patient ID',
            fieldType: 'text',
        },
        {
            id: 'patientName',
            name: 'patientName',
            find: 'patientName',
            label: 'Patient Name',
            fieldType: 'text',
        },
        {
            id: 'encounterDate',
            name: 'encounterDate',
            find: 'encounterDate',
            label: 'Encounter Date',
            fieldType: 'datetime',
        },
        {
            id: 'providerName',
            name: 'providerName',
            find: 'providerName',
            label: 'Provider Name',
            fieldType: 'text',
        },
        {
            id: 'pendingSyncType',
            name: 'pendingSyncType',
            find: 'pendingSyncType',
            label: 'Pending Sync Type',
            fieldType: 'text',
        },
        {
            id: 'status',
            name: 'status',
            find: 'status',
            label: 'Status',
            fieldType: 'text',
        },
        {
            id: 'action',
            name: 'rowAction',
            label: 'Action',
            fieldType: 'menuActionButtonV2',
            choices: Object.values(patientPortalEncounterSyncActions),
            dataSourceConfig: {
                text: 'value',
                value: 'key',
            },
            headerStyle: {
                fontSize: '14px',
                width: '8%',
            },
        },
    ],
    grid: {
        sm: 12,
        md: 12,
        lg: 12,
    },
};
